const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/stats/releases.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { getReleasesByMonth } from "@/components/charts/releases/monthly";
import { getReleasesByYear } from "@/components/charts/releases/yearly";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/stats/releases")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context
  }) => {
    const {
      queryClient
    } = context;
    await Promise.allSettled([queryClient.prefetchQuery({
      queryKey: ["releases-by-month"],
      queryFn: () => getReleasesByMonth().catch(() => null)
    }), queryClient.prefetchQuery({
      queryKey: ["releases-by-year"],
      queryFn: () => getReleasesByYear().catch(() => null)
    })]);
  },
  head: () => {
    return {
      meta: [{
        title: i18n.t("stats.releases.meta.title")
      }, {
        name: "description",
        content: i18n.t("stats.releases.meta.description")
      }]
    };
  }
});